var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio",attrs:{"preload":"none"},on:{"ended":_vm.ended,"loadeddata":_vm.loadeddata,"play":_vm.play,"playing":_vm.playing,"pause":_vm.pause,"timeupdate":_vm.timeupdate,"suspend":_vm.suspend}})}
var staticRenderFns = []

export { render, staticRenderFns }